var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSqlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 121,
    viewBox: "0 0 115 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sql-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 90",
    d: "M13.9734 15.002C13.074 16.0219 13.5987 17.8705 13.9734 18.6674L10.6006 18.508L11.0824 11.1773L23.9316 4.96215L50.1117 4.48406L68.2611 10.3805V12.9303C61.8366 9.87051 54.4483 8.78687 51.5572 8.62752C44.7472 7.86258 37.5838 8.09631 34.8533 8.30879C18.9204 10.0937 14.2947 13.5146 13.9734 15.002Z",
    fill: "#056945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 91",
    d: "M83.0375 19.7829C82.909 15.4482 80.2 12.4522 78.8616 11.4961L77.5767 63.4482L69.2247 70.1415L53.9663 80.5L39.3504 84.006L29.7136 103.448L4.81836 99.6235C12.7848 106.763 28.2681 109.079 35.0139 109.345C35.9133 109.345 36.0311 108.388 35.9775 107.91C35.9775 89.5518 50.2187 85.7059 57.3392 86.0777C58.4957 86.0777 59.106 85.4403 59.2666 85.1216C67.7792 72.2132 78.3797 71.0976 80.7889 71.0976C82.7163 71.0976 83.0911 69.3978 83.0375 68.5478V19.7829Z",
    fill: "#056945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6717 0.5C17.3464 0.5 0 7.83068 0 17.2331L3.48901e-05 91.9741C3.48901e-05 101.695 21.683 106.954 33.0866 107.751C34.0503 107.751 34.2017 107.432 34.2109 106.795C34.369 95.8177 38.9813 91.4759 40.2548 90.2771C40.2755 90.2576 40.2953 90.2389 40.3142 90.2211C46.224 84.6434 53.1098 84.3247 56.215 84.4841C57.4778 84.4841 57.7212 84.0224 57.9687 83.5527L57.9818 83.5279C63.2821 73.488 75.6494 69.3446 79.5041 69.3446C81.1103 69.3446 81.1103 68.3884 81.1103 67.1135V17.2331C80.9818 5.12151 53.4846 0.5 39.6717 0.5ZM27.4651 52.9303V47.5119C27.4495 47.5068 27.4276 47.4993 27.3996 47.4898C26.568 47.207 20.4127 45.1135 16.0615 47.5119C14.616 48.3088 12.528 50.8586 12.528 53.4084C12.528 54.8426 12.9135 58.7629 18.9526 60.4203C19.9163 60.6848 21.3618 61.1679 21.3618 62.6514C21.3618 63.2888 20.5587 64.0857 18.9526 64.0857C17.9756 64.0857 15.7082 63.6713 13.0098 62.0139V67.751C13.8129 68.2291 16.2221 69.0259 19.4344 69.0259C23.2892 69.0259 28.4747 67.4309 28.5894 62.6514C28.708 57.7089 25.5862 56.4161 22.9101 55.3079C21.9622 54.9154 21.0703 54.546 20.3981 54.0458C19.9281 53.6961 19.2509 52.4522 20.3981 51.6554C21.3618 50.9861 23.2249 50.7629 27.4651 52.9303ZM30.1956 58.1892C30.1956 53.249 32.7654 46.5558 41.1173 46.5558C45.9358 46.5558 52.0391 49.1056 52.0391 57.5518C52.0391 59.6235 51.9427 62.5558 48.9874 65.998L54.2877 71.4163H46.257L43.6872 68.8665C38.8687 68.8665 30.1956 68.8665 30.1956 58.1892ZM55.0908 46.8745H61.676V63.4482H69.0642V65.998V68.5478H55.0908V46.8745ZM11.8856 15.4801C11.8856 12.6116 18.3102 6.71516 39.6719 6.71516C50.5937 6.71516 69.0643 8.78688 69.0643 15.002C68.7431 22.3327 50.5937 23.6076 39.6719 24.0857C31.1676 24.4579 11.8856 21.2172 11.8856 15.4801Z",
    fill: "url(#paint0_linear_38_297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 88",
    d: "M41.1174 52.1335C37.7447 52.1335 37.102 55.7988 37.1021 58.0299C37.1022 62.1733 39.1902 63.2888 41.1174 63.2888C44.0086 63.2888 45.1328 60.5797 45.1328 58.0299C45.1328 53.249 42.8843 52.1335 41.1174 52.1335Z",
    fill: "url(#paint1_linear_38_297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 93",
    d: "M105.363 104.723C107.419 91.8466 102.365 84.909 99.5811 83.0498L102.954 105.998L105.363 104.723Z",
    fill: "#056945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 94",
    d: "M115 113.647C115 109.95 113.394 108.176 112.591 107.751L106.166 116.994L45.6147 116.038C48.024 118.906 52.6818 120.5 53.9667 120.5H108.415C111.627 120.5 115 118.11 115 113.647Z",
    fill: "#056945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 92",
    d: "M61.5154 89.1055C60.3621 91.9028 57.6607 90.2649 55.8939 90.0617C44.8115 88.7868 39.6719 99.9421 39.6719 104.723C39.6719 110.301 42.9212 114.125 44.6509 115.4C48.9875 118.597 52.6816 119.225 54.1272 119.225H105.684C111.948 119.225 113.554 114.287 113.554 111.735C113.554 105.998 108.736 104.564 105.684 104.723C103.918 104.723 103.275 103.767 103.596 103.129C105.283 99.7828 104.399 93.0895 103.596 90.0616C102.151 84.6114 94.602 74.7628 81.7528 74.7628C69.2249 74.7628 62.961 85.5996 61.5154 89.1055Z",
    fill: "url(#paint2_linear_38_297)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_297",
    x1: 32.6048,
    y1: 6.07769,
    x2: 79.1097,
    y2: 56.6397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40065,
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605404,
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_297",
    x1: 35.1748,
    y1: 50.6992,
    x2: 45.9996,
    y2: 63.2134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_297",
    x1: 62.1579,
    y1: 72.8506,
    x2: 86.7691,
    y2: 113.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0925116,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658716,
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.990512,
    stopColor: "#01A66B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlLogo);
export default __webpack_public_path__ + "static/media/sql-logo.4a18a35c91dce2552ef9b41fe58d55d5.svg";
export { ForwardRef as ReactComponent };